webpackJsonp([73],{

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_filters__ = __webpack_require__(278);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function closeDialog() {
	this.rowId = 0;
	this.dialog = false;
}

function columnSortableEvent() {}

function goTo(route) {
	this.$router.push({ name: 'companies-' + route, params: { id: this.id } });
}

function goToEdit(_ref) {
	var id = _ref.id;

	this.rowId = id;
	this.dialog = true;
}

function searchByColumn() {}

function data() {
	return {
		columns: [{ id: 1, name: '# Reserva', code: 'booking_code', isSortable: { down: true, up: false } }, { id: 2, name: 'Fecha de reserva', code: 'booking_date', isSortable: { down: true, up: false } }, { id: 3, name: 'Habitación', code: 'room_type_code', isSortable: { down: true, up: false } }, { id: 4, name: 'Check In', code: 'booking_start', isSortable: { down: true, up: false } }, { id: 5, name: 'Check Out', code: 'booking_end', isSortable: { down: true, up: false } }, { id: 6, name: 'Gasto Total', code: 'total_expenses', isSortable: { down: true, up: false } }],
		columnsDetails: [{ id: 1, name: 'Fecha', code: 'date', isSortable: { down: true, up: false } }, { id: 2, name: 'Hora', code: 'hour', isSortable: { down: true, up: false } }, { id: 3, name: 'Producto', code: 'name', isSortable: { down: true, up: false } }, { id: 4, name: 'Gasto', code: 'total', isSortable: { down: true, up: false } }],
		details: [{ id: 1, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 2, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 3, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 4, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 5, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 6, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 7, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 8, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 9, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 10, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 11, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 12, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 12, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 14, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 15, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 16, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 17, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 18, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 19, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 20, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 21, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 22, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 23, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 24, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 25, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 26, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 27, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 28, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 29, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 30, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 31, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 32, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 33, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 34, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 35, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 36, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 37, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 38, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 39, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 40, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 41, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 42, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 43, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 44, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }, { id: 45, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 }, { id: 46, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 }],
		dialog: false,
		params: {
			page: 1
		},
		rowId: 0,
		rows: [{
			id: 1,
			bookingCode: '186989',
			bookingDate: '2018-08-15',
			bookingEnd: '2017-05-29 13:35:35',
			bookingStart: '2017-05-29 13:35:35',
			currency: '$',
			roomTypeCode: 'DSQ',
			totalExpenses: 180
		}, {
			id: 2,
			bookingCode: '186989',
			bookingDate: '2018-08-15',
			bookingEnd: '2017-05-29 12:17:30',
			bookingStart: '2017-05-29 12:17:30',
			currency: '$',
			roomTypeCode: 'DSQ',
			totalExpenses: 180
		}],
		totalExpenses: 0,
		totalPages: 1
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'companies-history',
	components: {
		TableRun: __WEBPACK_IMPORTED_MODULE_0_table_run___default.a
	},
	data: data,
	filters: {
		currency: __WEBPACK_IMPORTED_MODULE_1__shared_filters__["a" /* currency */],
		parseDate: __WEBPACK_IMPORTED_MODULE_1__shared_filters__["b" /* parseDate */],
		round: __WEBPACK_IMPORTED_MODULE_1__shared_filters__["c" /* round */]
	},
	methods: {
		closeDialog: closeDialog,
		columnSortableEvent: columnSortableEvent,
		goTo: goTo,
		goToEdit: goToEdit,
		searchByColumn: searchByColumn
	},
	props: {
		id: {
			default: 0,
			type: [Number, String]
		}
	}
});

/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".header-booking-data[data-v-03fc1306]{height:31px;position:absolute;right:20px;text-align:right;top:55px;width:calc(100% - 230px)}.header-booking-data div[data-v-03fc1306]{padding-bottom:0!important;padding-top:0!important}.header-booking-data p[data-v-03fc1306]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}.header-booking-data span[data-v-03fc1306]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.btn-tab[data-v-03fc1306]{border-bottom:3px solid transparent}.btn-tab.active[data-v-03fc1306],.btn-tab[data-v-03fc1306]:hover{border-color:#29abe2}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/companies/companies-history.vue"],"names":[],"mappings":"AACA,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,wBAA0B,CAC3B,AACD,0CACI,2BAA+B,AAC/B,uBAA4B,CAC/B,AACD,wCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC7B,AACD,2CACI,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACnB,AACD,0BACE,mCAAqC,CACtC,AACD,iEACI,oBAAsB,CACzB","file":"companies-history.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.header-booking-data[data-v-03fc1306] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 55px;\n  width: calc(100% - 230px);\n}\n.header-booking-data div[data-v-03fc1306] {\n    padding-bottom: 0px !important;\n    padding-top: 0px !important;\n}\n.header-booking-data p[data-v-03fc1306] {\n    color: #2e394b;\n    font-family: \"San Francisco Display\";\n    font-size: 10px;\n    margin: 0px;\n    text-transform: uppercase;\n}\n.header-booking-data span[data-v-03fc1306] {\n    color: #29abe2;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 15px;\n}\n.btn-tab[data-v-03fc1306] {\n  border-bottom: 3px solid transparent;\n}\n.btn-tab[data-v-03fc1306]:hover, .btn-tab.active[data-v-03fc1306] {\n    border-color: #29abe2;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1364);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("ce8efed0", content, true);

/***/ }),

/***/ 1571:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.id) ? _c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('p', [_vm._v("Gasto Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.totalExpenses)))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-edit'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('edit')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tDetalle\n\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-statistics'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('statistics')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEstadística\n\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-history'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('history')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tHistorial\n\t\t\t\t")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-options": "",
      "include-settings": ""
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "go-to-edit-page": _vm.goToEdit
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.bookingCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.bookingDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.roomTypeCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.bookingStart, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.bookingEnd, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.totalExpenses), props.row.currency)))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.params.page = $$v
      },
      expression: "params.page"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "644"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [_c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columnsDetails,
      "rows": _vm.details,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": false,
      "include-settings": false,
      "include-search": false,
      "selectable": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.hour, 'HH:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.total), props.row.currency)))])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "my-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeDialog($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tCerrar\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1449)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1271),
  /* template */
  __webpack_require__(1571),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03fc1306",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/73.174ba0af9938152002bb.js